import { useContext } from 'react';
import { getLabel } from '../../../data/labels';
import { formatDate } from '../../utils/formatDate';
import { getCheckbetUrl } from '../../utils/getCheckbetUrl';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getHiddenTicket } from '../../utils/getHiddenTicket';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { oddToString } from '../../utils/oddToString';
import { CashoutConfigurationContext } from '../../cashout/CashoutConfigurationCtx';
import { MyBetsContext } from './MyBetsContext';
import ReloadTicketSection from './ReloadTicketSection';
import ShareCardDownloader from './ShareCardDownloader';
import Winnings from './Winnings';

function getTicketType(type) {
	switch (type) {
		case 'singlebets':
			type = getLabel('mybets.singola');
			break;
		case 'multibets':
			type = getLabel('mybets.multipla');
			break;
		case 'systembets':
			type = getLabel('mybets.sistema');
			break;
		default:
			break;
	}

	return type;
}

function BetInfo(props) {
    const ticket = props.ticket;
    const conf = getConfiguration();
    const cashoutConfigurationContext = useContext(CashoutConfigurationContext);
    const currency = getCurrencySymbol(conf.cs.ct);
    const isCashoutable = (cashoutConfigurationContext.cashoutData.enabled && ticket.isCashoutable && !props.isCheckbet);
    const myBetsContext = useContext(MyBetsContext);
    const ticketUrl = getCheckbetUrl(ticket.id);
    const amount = getPrintableAmount(ticket.cashoutAmount, conf.cs.m, conf.cs.nd);
    const amountWithCurrency = `${amount} ${currency}`;
    const bonusAmount = ticket.bonusAmount || props.ticketData?.bonusAmount;

    let disclaimerCashout = getLabel('cashout.disclaimer');
    disclaimerCashout = disclaimerCashout.replace(/{{AMOUNT}}/g, amountWithCurrency);

    const totalOdd = props.isBetBuilder && props.typeOfBetBuilder === 'ESTERO'? ticket.betBuilderTotalOdd : ticket.totalOdds;

    function cashout() {
        myBetsContext.showPreCashoutDisclaimer(ticket.id, ticket.amount, ticket.cashoutAmount, ticket.isLive);
    }

    return (
        <>
            <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_1">
                <div className="d-flex flex-column text-small | mb_5_3_1_1">
                    <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.importo')}</span>
                    <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                </div>
                {bonusAmount > 0 &&
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('general.bonus')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(bonusAmount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                }
                {totalOdd > 0 &&
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.quotatotale')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{oddToString(totalOdd)}</span>
                    </div>
                }
                <Winnings {...ticket} />
                <div className='button__ticket__wrapper'>
                    {!(window?.appConfig?.SHOP_MODE) && !props.isSnapshot &&
                        <>
                            <ShareCardDownloader
                                status={props.ticket.status}
                                ticketUrl={ticketUrl}
                                ticketId={props.ticket.id}
                                dateTimestamp={props.ticket.timestamp}
                                totalOdd={oddToString(totalOdd)}
                                totalAmount={getPrintableAmount(ticket.amount, conf.cs.m, conf.cs.nd)}
                                winPot={getPrintableAmount(props.ticket.potentialWinnings, conf.cs.m, conf.cs.nd)}
                            />
                            <ReloadTicketSection isCheckbet={props.isCheckbet} ticket={props.ticket} />
                        </>
                    }
                    {isCashoutable && !props.isSnapshot &&
                    <>
                        <div className="d-flex flex-column text-small var-disclaimer var-disclaimer-wh | mb_5_3_4_1">
                            <span className="text-medium bold | mb_5_3_4_1_1">
                                {disclaimerCashout} {conf.iwh && amountWithCurrency}
                            </span>
                        </div>
                        <button onClick={cashout} className="bottone bet-info bet-info-wh button__cashout | mb_5_3_4_2">
                            <span className="moneyIconContainer | mb_5_3_4_2_1" />
                            {getLabel('cashout.button_text')} {conf.iwh && amountWithCurrency}
                        </button>
                    </>
                    }
                </div>
            </div>
            <hr className="mb_4" />
            <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey tuples-toggle | mb_5_3_3">
                <span className="mb_5_3_3_1">{getTicketType(ticket.type)}</span>
                <div className="d-flex justify-content-space-between | mb_5_3_3_2">
                    <span className="mb_5_3_3_2_1">Ref. {props.obfuscateTicketId ? getHiddenTicket(ticket.id) : ticket.id}</span>
                    <span className="margin-left-right | mb_5_3_3_2_2">|</span>
                    <span className="mb_5_3_3_2_3">{formatDate(ticket.timestamp).formatted}</span>
                </div>
            </div>
        </>
    );
}

export default BetInfo;